import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';

export const createIssueAri = (cloudId: string, issueId: string): string =>
	createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'issue',
		resourceId: issueId,
	});
